var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 23,
    fill: "white",
    stroke: "white",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 4C13.685 4 4 13.685 4 25.6667C4 37.6483 13.685 47.3333 25.6667 47.3333C37.6483 47.3333 47.3333 37.6483 47.3333 25.6667C47.3333 13.685 37.6483 4 25.6667 4ZM25.6667 43C16.1117 43 8.33333 35.2217 8.33333 25.6667C8.33333 16.1117 16.1117 8.33333 25.6667 8.33333C35.2217 8.33333 43 16.1117 43 25.6667C43 35.2217 35.2217 43 25.6667 43ZM33.445 14.8333L25.6667 22.6117L17.8883 14.8333L14.8333 17.8883L22.6117 25.6667L14.8333 33.445L17.8883 36.5L25.6667 28.7217L33.445 36.5L36.5 33.445L28.7217 25.6667L36.5 17.8883L33.445 14.8333Z",
    fill: "#FF003D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPayment);
export default __webpack_public_path__ + "static/media/ErrorPayment.c3cf9e687a45f55fe84b1457dfe59359.svg";
export { ForwardRef as ReactComponent };